import React from 'react';
import { Modal } from "react-bootstrap";
import '../beneficiary.css';
import { useDispatch } from 'react-redux';
import { setBeneficiaryAuthType, updateChild } from '@store/actions/beneficiaryAction';
import OTP from '../../../assets/svg_main/beneficiary/Register with OTP.svg';
import Demographics from '../../../assets/svg_main/beneficiary/Register with D.svg';
import { RootState } from '@store/reducers';
import { useSelector } from 'react-redux';
import { benef_const } from '@constants/beneficiaryConstant';


interface showModalProps {
    showModal: boolean;
    handleClose: (authType: string) => void;
};

const AuthenticationOptionModal = ({ showModal, handleClose }: showModalProps) => {
    const beneficiary = useSelector((state: RootState) => state.beneficiary);
    const dispatch = useDispatch();
    const handleAuthClick = (authType: string) => {
        dispatch(setBeneficiaryAuthType(authType));
        handleClose(authType);
    };
    function handleBackClick(): void {
        handleClose('back');
    }

    function handleDiscardClick(): void {
        dispatch(updateChild('isChildRegistration', false));
        handleAuthClick('')
    }


    return (
        <>
            <div className="modal_auth_beneficiaries">
                <Modal
                    show={showModal}
                    onHide={() => handleAuthClick('')}
                    dialogClassName={'auth-card-modal'}
                    centered={true}
                    backdrop ="static"
                >
                    <Modal.Header>
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "400px" }}>
                            <div className="d-flex align-items-center beneficiary_back_button" onClick={handleBackClick}>
                                <i className="bi bi-arrow-left" style={{ cursor: "pointer" }} ></i>
                                <span className="ms-1">Back</span>
                            </div>
                            <div className="d-flex align-items-center beneficiary_discard_button" onClick={handleDiscardClick}>
                                <span className="me-0">Discard</span>
                                <i className="bi bi-x" ></i>
                            </div>

                        </div>
                    </Modal.Header>

                    <Modal.Body  >
                        <div className='auth-container'>
                            <div className='auth-box' onClick={() => handleAuthClick('OTP')}>
                                <OTP />
                                Register with OTP
                            </div>
                            {beneficiary?.beneficiaryRedgeOption !== benef_const.verifyOptions.abha && <div className='auth-box' onClick={() => handleAuthClick(benef_const.verifyOptions.demographics)}><Demographics />Register with Demographics</div>}
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
};

export default AuthenticationOptionModal;